import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
//import { actionCreators } from '../store/WeatherForecasts';
import { actionCreators } from '../store/actions/dataActions';
// Import React Table
import ReactTable from "react-table";
import "react-table/react-table.css";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Shortlist from './shortlist';
import ListShortlists from './ListShortLists';
import ShortListFromISRC from './ShortListFromISRC';
import "react-table/react-table.css";
import Select from 'react-select';
import ReadyShortlist from './ReadyShortListsTable';
import Corrections from './Corretions';
import { CSVLink } from 'react-csv';



class Home extends Component {

    constructor(props) {
        super(props);
        this.state = {
            filtered: [],
            select2: undefined
        };
     
    }
componentDidMount() {
    // This method is called when the component is first added to the document
   
    this.ensureDataFetched();
   
}

componentDidUpdate() {
    // This method is called when the route parameters change
    //this.ensureDataFetched();
}

ensureDataFetched() {
    const startDateIndex = parseInt(this.props.match.params.startDateIndex, 10) || 0;
    // this.props.requestWeatherForecasts(startDateIndex);
    this.props.requestShortList(false);
    this.props.requestShortList(true);
    this.props.getData();
   
 
    }

    onFilteredChangeCustom = (value, accessor) => {
        let filtered = this.state.filtered;//this.props.filtered;
        let insertNewFilter = 1;

      
        
            if (filtered.length) {
                filtered.forEach((filter, i) => {
                    if (filter["id"] === accessor) {
                        if (value === "" ||  value === null) filtered.splice(i, 1);
                        else filter["value"] = value;
                        insertNewFilter = 0;
                    }
                });
            }

            if (insertNewFilter) {
                filtered.push({ id: accessor, value: value });
            }



      
        //this.props.setCatalogueFilter(filtered);
        this.setState({ filtered: filtered });
    };


render() {
    const access = localStorage.getItem("accessToken");
   
    let url = this.props ? this.props.audioURL : '';
    return (
        <div> <Tabs selectedIndex={this.props.tabIndex} onSelect={tabIndex => this.props.setTab( tabIndex)}>
            <TabList>
                <Tab>
                    Audio Library
        </Tab>
                <Tab >
                    Product Assets ({this.props.tempShortList != null ? this.props.tempShortList.length : 0})
        </Tab>
                <Tab>
                    Products in progress ({this.props.isLoadingShortlists?"Loading":this.props.shortLists != null ? this.props.shortLists.length : 0})
        </Tab>
               
               
                <Tab>
                    Products Approval ({this.props.isLoadingReadyShortLists? "Loading":  this.props.shortListsReady != null ? this.props.shortListsReady.length : 0})
                </Tab>
            </TabList>
            <TabPanel><div className="container">
                <h1>Audio Library</h1>

                <div className="row">
                    <div className="col-sm-4">
                        <span>Catalog</span>
                        <Select
                            style={{ width: "50%", marginBottom: "20px" }}
                            onChange={entry => {

                                this.props.setCatalogsSelected(entry);

                                this.onFilteredChangeCustom(
                                    entry !== null ?
                                        entry.map(o => {
                                            return o.value;
                                        }) : null,
                                    "catalog"
                                );


                            }}
                            value={this.props.select2}
                            isMulti={true}
                            options={this.props.catalogues.map((o, i) => {
                                return { id: i, value: o, label: o };
                            })}
                        />
                    </div>
                    <div className="col-sm-4">
                        <span>Genre</span>
                        <Select
                            style={{ width: "50%", marginBottom: "20px" }}
                            onChange={entry => {

                                this.props.setGenresSelected(entry);

                                this.onFilteredChangeCustom(
                                    entry !== null ?
                                        entry.map(o => {
                                            return o.value;
                                        }) : null,
                                    "genre"
                                );


                            }}
                            value={this.props.genresSelect}
                            isMulti={true}
                            options={this.props.genres.map((o, i) => {
                                return { id: i, value: o, label: o };
                            })}
                        />
                    </div>
                </div>
               
                <br/>

             


                <div className="row">
                    <div className="col-sm-12">
                        {this.props.summary != null ? <CSVLink data={this.props.summary} >Download me</CSVLink> : ""}
                        {this.props.summary != null ? renderReactTable(this.props.summary, this.props, this) : "Loading"}
                    </div>
                </div>

            </div> </TabPanel>
            <TabPanel> <Shortlist /></TabPanel>
            <TabPanel> <ListShortlists /></TabPanel>        
            <TabPanel> <ReadyShortlist /></TabPanel>
        </Tabs>          
            
            
          

        </div>
    );
}
}



function renderReactTable(data, props,main) {

  
    const onRowClick = (state, rowInfo, column, instance) => {
        if (typeof rowInfo !== "undefined") {
            return {
              
                style: {
                    background: props.tempShortList && props.tempShortList.filter(t => t.isrc === rowInfo.original.isrc).length > 0 ? '#00afec' : 'white',
                    color: props.tempShortList && props.tempShortList.filter(t => t.isrc === rowInfo.original.isrc).length > 0 ? 'white' : 'black',
                    
                }
            }
        } else {
            return {
                onClick: (e, handleOriginal) => {
                    if (handleOriginal) {
                        handleOriginal()
                    }
                }
            }
        }
    }
    return (
        <ReactTable
            getTrProps={onRowClick}
            data={data}
            filterable
            filtered={main.state.filtered}
            onFilteredChange={(filtered, column, value) => {
                main.onFilteredChangeCustom(value, column.id || column.accessor);
            }}
          
            defaultFilterMethod={(filter, row, column) => {
                const id = filter.pivotId || filter.id;                
                if (typeof filter.value === "object") {                    
                    return row[id] !== undefined || row[id] !==  null
                        ? filter.value.indexOf(row[id]) > -1
                        : true;
                } else {
                    return row[id] !== undefined
                        ? String(row[id]).toLowerCase().indexOf(filter.value.toLowerCase()) !== -1
                        : true;
                }
            }}

              
            columns={[
                {
                    Header: "Basic Data",
                    columns: [
                        {
                            Header: "ISRC",
                            accessor: "isrc",
                            Cell: row => (
                                <span style={{ cursor: 'pointer' }} onClick={() => props.selectTrack(row.value)}> {props.tempShortList && props.tempShortList.filter(t => t.isrc === row.value).length > 0 ? row.value : row.value}</span>
                            )
                        },
                        {
                            Header: "Audio",
                            accessor: "fugaID",
                            Cell: row => (
                                <button onClick={() => props.setAudioUrl(row.value)}> {props.audioURL === row.value ? "Playing" : "Play"}</button>
                            ),
                            Filter: ({ filter, onChange }) => {
                                return ("")
                            }
                        },
                        {
                            Header: "Title",
                            accessor: "name"
                        },
                        {
                            Header: "Artist",
                            accessor: "displayArtist"
                        },
                        {
                            Header: "Original Artist",
                            accessor: "originalArtist"
                        },
                        {
                            Header: "Version",
                            accessor: "version"
                        },
                        {
                            Header: "Genre",
                            accessor: "genre",
                            Filter: ({ filter, onChange }) => {
                                return ("")
                            }
                        },
                        {
                            Header: "SubGenre",
                            accessor: "subgenre"
                        },
                        {
                            Header: "Catalog",
                            accessor: "catalog",
                            Filter: ({ filter, onChange }) => {
                                return ("")
                            }
                        },                      
                        {
                            Header: "Recording Year",
                            accessor: "recordingYear"
                        },
                        {
                            Header: "Language",
                            accessor: "lop"
                        },
                        {
                            Header: "Tags",
                            accessor: "tags",
                            Cell: row => <div><span title={row.value}>{row.value}</span></div>

                        },
                        {
                            Header: "Tag Visible",
                            accessor: "tag_visible",
                            Cell: row => <div><span title={row.value}>{row.value}</span></div>

                        },
                        {
                            Header: "Tag Hidden",
                            accessor: "tag_hidden",
                            Cell: row => <div><span title={row.value}>{row.value}</span></div>

                        },
                        {
                            Header: "BPM",
                            accessor: "bpm"
                        },
                        {
                            Header: "Key",
                            accessor: "key"
                        },
                        {
                            Header: "Quality",
                            accessor: "quality"                       

                        },
                        {
                            Header: "Products",
                            accessor: "products"
                        },
                       

                    ]
                }
            ]}
            defaultSorted={[
                {
                    id: "name",
                    desc: true
                }
            ]}
            defaultPageSize={50}
            style={{
                height: "600px" // This will force the table body to overflow and scroll, since there is not enough room
            }}
            className="-striped -highlight"
        />)
};





export default connect(
    state => state.data,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(Home);



// WEBPACK FOOTER //
// ./src/components/Home.js